import { isMiniHostAppFeatureEnabled } from 'mini-hostapp-feature-flags/lib/isMiniHostAppFeatureEnabled';
import { isNativeFeatureEnabled } from 'mini-host-bridge/lib/utils/isNativeFeatureEnabled';
import { isNonPrivateCloud } from 'mini-common-utils/lib/utils/isNonPrivateCloud';

export const isWhatsNewFeatureEnabled = () =>
    isMiniHostAppFeatureEnabled('nativeHost')
        ? isNativeFeatureEnabled('whats-new')
        : isNonPrivateCloud();
